// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

import { locale } from '@/i18n';

/**
 * "12 Jul 14:32" in the app's language, from the photo's ISO timestamp.
 *
 * Follows the `Intl.DateTimeFormat(locale(), …)` convention in features/statistics/formatting.ts,
 * with an ISO fallback for the case where the runtime has no ICU data for the locale.
 *
 * Returns an empty string for a missing or unparseable value, so callers can omit the line rather
 * than print "Invalid Date".
 */
export const formatTakenAt = (isoTimestamp: string | null | undefined): string => {
  const raw = isoTimestamp?.trim();
  if (!raw) {
    return '';
  }

  const date = new Date(raw);
  if (Number.isNaN(date.getTime())) {
    return '';
  }

  try {
    return new Intl.DateTimeFormat(locale(), {
      day: 'numeric',
      month: 'short',
      hour: '2-digit',
      minute: '2-digit',
    }).format(date);
  } catch {
    // Trim the seconds and the trailing Z: "2026-08-11T09:00" reads better than the raw value.
    return raw.replace('T', ' ').slice(0, 16);
  }
};
